import React from "react";
import lookupStore from "../stores/lookupStore";
import MainStore from "../stores/MainStore";
import OptionItem from "./OptionItem";

export const DisplayedOptions = () => {
  const { displayedOptions, setCreate } = MainStore();
  const { activeSearch } = lookupStore();

  function createStuff(type) {
    setCreate({ payload: { shortDescription: activeSearch }, type });
  }

  return (
    <div className="divColumn" style={{ width: "100%" }}>
      {displayedOptions.map((o) => (
        <OptionItem
          name={o.name}
          image={o.image}
          onClick={createStuff}
          func={o.func}
          color={o.color}
          key={o.name}
        />
      ))}
    </div>
  );
};
